import { render } from "./EditorHtml.vue?vue&type=template&id=4acc6087&ts=true"
import script from "./EditorHtml.vue?vue&type=script&lang=ts"
export * from "./EditorHtml.vue?vue&type=script&lang=ts"

import "./EditorHtml.vue?vue&type=style&index=0&id=4acc6087&lang=css"

import exportComponent from "D:\\DefesaCivil\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__